import { HttpClient } from '@angular/common/http';
import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import { VhQueryAutoWeb, VhImage, VhEventMediator } from 'vhautowebdb';
import { forkJoin } from 'rxjs';
// import { ManageLibraryComponent } from '../../../../manage-library/manage-library.component'
import { AtwUpdateDbComponent } from 'vhobjects-service';
import { FunctionService  } from 'vhobjects-service';


@Component({
  selector: 'atw-frame-reply-comment-admin-config',
  templateUrl: './frame-reply-comment-admin-config.component.html',
  styleUrls: ['./frame-reply-comment-admin-config.component.scss']
})
export class AtwFrameReplyCommentAdminConfig extends AtwUpdateDbComponent implements OnInit {
@Input() objectChoosing: any; // lấy giá trị data trả vể từ page
  @Input() device: any; // xác định device là desktop hay mobile
  @Input() position: any; // xác định position là desktop hay mobile
  @Input() class: any; // là dữ liệu desktop_class hoặc mobile_portrait_class từ database
  @Input() config: any; // là dữ liệu desktop_config hoặc mobile_portrait_config từ database
  @Input() type: any; // xem đang ở page hay admin
  @Input() staticdata: any; // là dữ liệu staticdata từ database
  @Output() changeOptionConfig = new EventEmitter<any>();
  isViewAll: boolean = false;
  isCollapsed: boolean = false;
  configMode: 'basic' | 'advanced' = 'basic';

  public urlBackgroundImage = ''; // Giá trị đường dẫn của background-image

  public openMenu: { [name: string]: boolean } = {
    menu1: true,
    menu2: false,
  };
  public currentViewAll: any = {};
  public stylesField = [
    {
      title: 'dieu_chinh_vien_khung',
      index: 1,
    },
    {
      title: 'cau_hinh_chi_tiet_hieu_ung',
      index: 2,
    }
  ];

  effect_hover = [];
  customize = [];

  constructor(
    public vhQueryAutoWeb: VhQueryAutoWeb,
    public vhEventMediator: VhEventMediator,
    private http: HttpClient,
    public functionService: FunctionService
  ) {
    super(vhQueryAutoWeb, vhEventMediator, functionService);
  }

  ngOnInit(): void {
    // Kiểm tra nếu chưa có config thì thêm để người dùng không cần xóa thêm lại
    if (!this.config.hasOwnProperty('position_onscroll')) {
      this.config.position_onscroll = {
        'type': 0,
        'top': 0
      };
    }

    // phần này get dữ liệu json
    forkJoin([
      this.http.get('assets/data/effects/frame-reply-comment.json')
    ]).subscribe(([effects]: any) => {
      this.effect_hover = effects;
    })
  }

  openHandler(value: string): void {
    for (const key in this.openMenu) {
      if (key !== value) {
        this.openMenu[key] = false;
      }
    }
  }


  /**
   * Hàm này dùng để mở rộng phần cấu hình.
   * @param field_text : trả về phần tử được chọn của mảng style_field
   */
  openViewAll(field_text) {
    this.currentViewAll = field_text;
    this.isViewAll = !this.isViewAll;
  }

  /** Hàm thực hiện gán giá trị background-image khi có thay đổi
   *
   */
  handleSetBackgroundImage() {
    this.class['frame-reply-comment']['background-image'] = this.class['frame-reply-comment'][
      'background_image_restore'
    ] = `url(${this.urlBackgroundImage})`;
    this.updateClass();
  }

  /** Hàm thực hiện xử lí khi chuyển lựa chon background
   *
   * @param event
   */
  handleSetBackground(event) {
    let frameBlank = this.config['frame-reply-comment'];
    if (event === 'color') {
      if (this.class['frame-reply-comment']['background-color'] == 'transparent') {
        this.class['frame-reply-comment']['background-color'] =
        frameBlank['background_color_restore'];
      }
      this.class['frame-reply-comment']['background-image'] = 'none';
    }
    if (event === 'image') {
      if (frameBlank['background-image'] == 'none') {
        this.class['frame-reply-comment']['background-image'] = `url("${this.config['frame-reply-comment']['background_image_restore']}")`
        // Xử lí cắt chuỗi background-image
        let backgroundImage = this.class['frame-reply-comment']['background-image'];
        const startIndex = backgroundImage.indexOf('(') + 1; // Tìm vị trí bắt đầu của phần tử aaa
        const endIndex = backgroundImage.lastIndexOf(')');
        this.urlBackgroundImage = backgroundImage.substring(
          startIndex,
          endIndex
        ); // Cắt phần tử url từ vị trí bắt đầu đến kết thúc
      }
      // this.class['frame-reply-comment']['background-color'] = 'transparent';
    }
    setTimeout(() => {
      this.updateClass();
      this.updateConfig();
    }, 0);
  }

  /** Hàm thực hiện xử lí khi có thay đổi trường background-color
   *
   */
  handleSetBackgroundColor(event) {
    this.config['frame-reply-comment']['background_color_restore'] = this.class[
      'frame-reply-comment'
    ]['background-color'] = event;
  }


  /** Hàm sẽ thực hiện disable các option khi lựa chọn tải ảnh nền cho frame
   *
   * @param valueItem
   * @returns
   */
  checkDisableUploadImage(valueItem: any) {
    if (this.config['frame-reply-comment'].is_upload_image === valueItem) return false;
    return true;
  }

  handleChangeContainer(event: any){
    this.config['frame-reply-comment__boundary']['is_container'] = event
    if(event){
      this.class['frame-reply-comment__boundary']['width'] = '75%';
      this.class['frame-reply-comment__boundary']['position'] = 'relative';
    }else{
      this.class['frame-reply-comment__boundary']['width'] = '100%';
      this.class['frame-reply-comment__boundary']['position'] = 'unset';

    }
    this.updateClass();
    this.updateConfig();
  }

  /**
  * Hàm này thay đổi box-shadow giữa có hiệu ứng và không có hiệu ứng.
  * Khi gọi hàm này thì hiệu ứng hover hiển thị box-shadow sẽ bị disable.
  * Ngược lại thì thì hiệu ứng hover hiển thị box-shadow enable.
  */
  onChangeShadow() {
    if (this.config['box-shadow']['shadow_check'] === false) {
      this.config['box-shadow']['offset_x'] = 0;
      this.config['box-shadow']['offset_y'] = 0;
      this.config['box-shadow']['blur_radius'] = 0;
      this.config['box-shadow']['shadow_color'] = '#333';
    }
    this.class['frame-reply-comment']['box-shadow'] = `${this.config['box-shadow']['offset_x']}px ${this.config['box-shadow']['offset_y']}px ${this.config['box-shadow']['blur_radius']}px ${this.config['box-shadow']['shadow_color']}`;
  }

}
